module.exports = __webpack_public_path__ + "img/fa-regular-400.e7e957c8.svg";